/* eslint-disable eqeqeq */
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
// common_groupstructure_GETROW
import Grid from "@mui/material/Grid";
// import WmsHead from "./processComponent/WmsHead";
// import "./BranchToDcTsrDetailReport.css";
import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
// import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  ReportRemoveSequenceChar,
  ReportUrl,
} from "../../Utility/Utilitys";
import WmsHead from "./processComponent/WmsHead";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";
import {
  common_LocationSearch_GETROW,
  common_UserLoading_GETROW,
} from "../../Server/ApiV2";
import { vRdxUserInfo } from "../../Redux/roStore";

// import {
//   HeadObjectInit,
//   sWebStockReportData,
//   sWebStockReportArr,
//   GetLocation,
//   fValidationHead_Client,
//   sWebBetweenReportArr,
// } from "./BranchToDcTsrDetailReportAction";

// import { set } from 'date-fns/esm';

export default function PickersPerformance() {
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const [userList, setUserList] = useState([]);
  const [sLocationData, setLocationData] = useState([]);

  let initHeadObj = {
    pFromDate: new Date(),
    pToDate: new Date(),
    pLocation: {},
    pUser: {},
    pReportType: "Summary",
  };
  //Head
  const [HeadObject, setHeadObject] = useState(initHeadObj);

  const fValidationHead = (HeadObject) => {
    let iRes = true;

    if (
      HeadObject.pFromDate === "" ||
      HeadObject.pFromDate === null ||
      HeadObject.pFromDate === undefined ||
      HeadObject.pFromDate === "Invalid Date" ||
      HeadObject.pToDate === "" ||
      HeadObject.pToDate === null ||
      HeadObject.pToDate === undefined ||
      HeadObject.pToDate === "Invalid Date"
    ) {
      fAlertToast("FAILED", "Date should not be empty");
      iRes = false;
      return iRes;
    }

    if (Object.keys(HeadObject.pLocation).length === 0) {
      fAlertToast("FAILED", "Location should not be empty");

      iRes = false;
      return iRes;
    }
    if (
      HeadObject?.pLocation?.Cd === "" &&
      HeadObject?.pLocation?.Cd === null &&
      HeadObject?.pLocation?.Cd === undefined
    ) {
      fAlertToast("FAILED", "Location should not be empty");

      iRes = false;
      return iRes;
    }
    // if (Object.keys(HeadObject.pUser).length === 0) {
    //   fAlertToast("FAILED", "User should not be empty");

    //   iRes = false;
    //   return iRes;
    // }

    // if (HeadObject.pUser.UId === "" && HeadObject.pUser.Name1 === "") {
    //   fAlertToast("FAILED", "User should not be empty");

    //   iRes = false;
    //   return iRes;
    // } else if (
    //   (HeadObject.pUser.UId == "" ||
    //     HeadObject.pUser.UId === null ||
    //     HeadObject.pUser.UId === undefined) &&
    //   HeadObject.pUser.Name1 != "All"
    // ) {
    //   fAlertToast("FAILED", "User should not be empty");

    //   iRes = false;
    // }
    if (
      HeadObject.pReportType === "" &&
      HeadObject.pReportType === null &&
      HeadObject.pReportType === undefined
    ) {
      fAlertToast("FAILED", "Report Type should not be empty");

      iRes = false;
      return iRes;
    }

    return iRes;
  };

  const fFromDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        pFromDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        pFromDate: e?.$d,
      }));
    }
  };
  const fToDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        pToDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        pToDate: e?.$d,
      }));
    }
  };

  const fReportType = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      pReportType: e.target.value,
    }));
  };
  const fCancel = (e) => {
    setHeadObject(initHeadObj);
  };

  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const GetReportsView = async () => {
    let urlPrint = vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val;
    let sCurrentReport = "";
    console.log(HeadObject.pFromDate, HeadObject.pToDate);

    // let ReportUrlObj = {
    //   TrnTyp: HeadObject.pReportType,
    //   Loc: HeadObject?.pLocation?.Cd || "",
    //   User: HeadObject?.pUser?.UId || "",
    //   Date1: moment(HeadObject.pFromDate).format("DD-MM-YYYY"),
    //   Date2: moment(HeadObject.pToDate).format("DD-MM-YYYY"),
    // };
    // console.log("ReportUrlObj", ReportUrlObj);

    // sCurrentReport = ReportUrl(ReportUrlObj);
    // sCurrentReport = ReportRemoveSequenceChar(sCurrentReport);
    sCurrentReport = `
    ${urlPrint}WMS/PickersPerformance?TrnTyp=${HeadObject.pReportType}&Loc=${
      HeadObject?.pLocation?.Cd
    }&User=${
      HeadObject?.pUser?.UId ? HeadObject?.pUser?.UId : "%20"
    }&Date1=${moment(HeadObject.pFromDate).format("MM-DD-YYYY")}&Date2=${moment(
      HeadObject.pToDate
    ).format("MM-DD-YYYY")}`;
    console.log(urlPrint + "WMS/PickersPerformance?" + sCurrentReport);

    setWebReportUrlModal(sCurrentReport);

    fWebReport();
  };

  const fPreview = async (e) => {
    let iValidationHead_Client = fValidationHead(HeadObject);
    if (!iValidationHead_Client) return;

    await GetReportsView();
  };

  //Modal fWebReportModal
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");

  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  const getUserList = async (location) => {
    const Obj = {
      P_location: location,
    };
    let response = await common_UserLoading_GETROW(
      fcheck_null_undefine_replace_empty(Obj)
    );

    if (response?.status === 200) {
      setUserList(response.data?.ResultSet);
    } else {
      setUserList([]);
    }
  };

  console.log("userList", userList);

  const GetLocation = async (setLocation) => {
    const vRdxUserInfoObj = vRdxUserInfo();
    //v_AnyData,v_Cd,v_Name,v_Distri,v_UserCd
    var vLocobj = {
      v_AnyData: "",
      v_Cd: "",
      v_Name: "",
      v_Distri: "Y",
      v_UserCd: vRdxUserInfoObj.UserID,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vLocobj);
    const vLocation = await common_LocationSearch_GETROW(FinalObj);
    if (vLocation?.status === 200) {
      setLocation(vLocation?.data?.ResultSet);
      return;
    }
  };

  const fLoad = async () => {
    let resp = await GetLocation(setLocationData);
    // getUserList(HeadObject.pLocation)
  };
  useEffect(() => {
    fLoad();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div></div>
        <div className="col-12">
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={vMediaQuery ? "py-4" : "py-4"}
          >
            <Grid item xs={12} sm={12} md={8}>
              <WmsHead
                sLocationData={sLocationData}
                HeadObject={HeadObject}
                setHeadObject={setHeadObject}
                fFromDate={fFromDate}
                fToDate={fToDate}
                userList={userList}
                fReportType={fReportType}
                getUserList={getUserList}
              />
            </Grid>
          </Grid>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 0, md: 0 }}
            columnSpacing={{ xs: 1, sm: 0, md: 3 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              vMediaQuery
                ? " justify-content-center text-center"
                : "py-2 justify-content-center text-center"
            }
          >
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Preview"
                xOnClick={fPreview}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Cancel"
                xOnClick={fCancel}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
          </Grid>
        </div>
      </div>

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </div>
  );
}
